import { IEmployee, IGoodRegistration, ISupplier, Locale } from "@lib";
import { Localizer } from "@/i18n/localizer";
import * as filters from "@/filters";

export function getDefaultTableColumns(context: any): any[] {
    return [
        {
            colId: "actions",
            headerName: "Изменить / Удалить",
            width: 70 + (context.can.update ? 25 : 0) + (context.can.delete ? 25 : 0),
            minWidth: 70 + (context.can.update ? 25 : 0) + (context.can.delete ? 25 : 0),
            hide: false,
            headerClass: "text-transparent",
            headerCheckboxSelection: true,
            checkboxSelection: true,

            cellRendererFramework: "CellRendererActions",
            cellRendererParams: (params: any) => {
                return {
                    actions: [
                        {
                            id: "edit",
                            description: "Изменить",
                            icon: "Edit3Icon",
                            classes: "h-1 w-1 mr-0.75 hover:text-primary cursor-pointer",
                            isVisible: (goodRegistration: IGoodRegistration) => context.can.update(goodRegistration),
                            click: (goodRegistration: IGoodRegistration) => context.showModalUpdate(goodRegistration),
                        },
                        {
                            id: "delete",
                            description: "Удалить",
                            icon: "Trash2Icon",
                            classes: "h-1 w-1 mr-0.75 hover:text-danger cursor-pointer",
                            isVisible: (goodRegistration: IGoodRegistration) => context.can.delete(goodRegistration),
                            click: (goodRegistration: IGoodRegistration) => context.confirmDelete(goodRegistration),
                        },
                    ],
                };
            },
        },
        {
            colId: "number",
            field: "number",
            headerName: "#",
            sortable: true,
            filter: true,
            width: 100,
            hide: false,
        },
        {
            colId: "supplier",
            field: "supplier",
            headerName: "Поставщик",
            sortable: true,
            filter: true,
            width: 220,
            hide: true,

            cellRendererFramework: "CellRendererChip",
            cellRendererParams: (params: any) => {
                const supplier = (context.suppliers as ISupplier[]).find(s => s.id === params.value);

                return {
                    name: supplier?.name,
                };
            },
        },
        {
            colId: "store",
            field: "store",
            headerName: "Склад",
            sortable: true,
            filter: true,
            width: 175,
            hide: false,

            cellRendererFramework: "CellRendererChip",
            cellRendererParams: (params: any) => {
                return {
                    name: params.data.storeRef?.info.name,
                };
            },
        },
        {
            colId: "employee",
            field: "employee",
            headerName: "Сотрудник",
            sortable: true,
            filter: true,
            width: 220,
            hide: false,

            cellRendererFramework: "CellRendererAvatar",
            cellRendererParams: (params: any) => {
                const employee = params.data.employeeRef;

                return {
                    showAvatar: true,
                    avatar: employee?.info.avatar ?? "",
                    name: employee?.info.name ?? "",
                };
            },
        },
        {
            colId: "date",
            field: "date",
            headerName: "Дата",
            sortable: true,
            filter: true,
            width: 175,
            hide: false,

            cellRenderer: function (params: any) {
                return filters.datetime.datetime(params.value, "L LT");
            },
        },
        {
            colId: "amount",
            field: "amount",
            headerName: "Сумма",
            sortable: true,
            filter: true,
            width: 150,
            hide: false,

            cellRenderer: function (params: any) {
                // TODO: брать локаль из склада
                const locale = Locale.RU;
                return Localizer.moneyFull(params.value, locale);
            },
        },
        {
            colId: "tags",
            field: "tags",
            headerName: "Метки",
            sortable: true,
            filter: true,
            width: 160,
            hide: false,

            // cellRendererFramework: "CellRendererChips",
            // cellRendererParams: (params: any) => {
            //     return {
            //         chips: params.value?.map((v: any) => ({ text: v })) ?? [],
            //     };
            // },

            cellRendererFramework: "CellRendererTags",
            cellRendererParams: (params: any) => {
                const tags = params.value;
                if (!tags) {
                    return;
                }

                return {
                    tags,
                    handler: (t: string) => context.table.api.search(t),
                };
            },
        },
        {
            colId: "comment",
            field: "comment",
            headerName: "Комментарий",
            sortable: true,
            filter: true,
            width: 500,
            hide: false,
        },
    ];
}
